<script lang="ts">
  import { navigating } from "$app/state";
  import { m } from "#messages";

  const NOTICEABLE_MS = 100;

  let waiting = $state(false);

  $effect(() => {
    if (navigating.to === null) {
      waiting = false;
      return;
    }
    const timer = setTimeout(() => (waiting = true), NOTICEABLE_MS);
    return () => clearTimeout(timer);
  });
</script>

{#if waiting}
  <div
    role="progressbar"
    aria-label={m.ui_loading()}
    class="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden"
    data-testid="navigation-progress"
  >
    <div class="bar h-full w-1/3 bg-accent"></div>
  </div>
{/if}

<style>
  .bar {
    animation: travel 1.1s ease-in-out infinite;
  }

  @keyframes travel {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(300%);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .bar {
      width: 100%;
      animation: none;
      opacity: 0.6;
    }
  }
</style>
